import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'


type ScrollableContainerProps = {
  className?: string
}

const ScrollableContainer: React.CFC<ScrollableContainerProps> = (props) => {
  const { children, className } = props
  const { isMobile } = useDevice()

  return (
    <div className={cx(className, isMobile && 'no-scrollbar -mx-16 touch-manipulation overflow-x-auto px-16')}>
      {children}
    </div>
  )
}


export default ScrollableContainer
